import { useMemo, useState } from "react";
import { useNavigate } from "react-router";

import { debounce } from "lodash";
import Actions from "../../../components/Common/Actions";
import AntdBreadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import FilledButton from "../../../components/Common/Buttons/FilledButton";
import DoctorsFilterOptions from "../../../components/Common/CommonFilterOptions";
import ListPageLayout from "../../../components/Layout";

const HHSPSpecialisation = () => {
  const navigate = useNavigate();
  const addNewHHSPSpecialization = {
    id: "addnewpost",
    onClick: () => navigate("/home-healthcare-hhsp-form"),
    style: { width: "240px" },
    label: "Add New HHSP Specialisation",
  };
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("newest");
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortName, setSortName] = useState("Newest First");

  // Full Data
  const fullData = [
    {
      sno: "01",
      hhsp: "Physiotheraphy",
      image: "",
      total: "268",
      status: "Active",
    },
    {
      sno: "02",
      hhsp: "Nursing Support Service",
      image: "",
      total: "1669",
      status: "Active",
    },
    {
      sno: "03",
      hhsp: "Mother & Baby Care Support",
      image: "",
      total: "297",
      status: "Active",
    },
    {
      sno: "04",
      hhsp: "Speech Thearopy",
      image: "",
      total: "116",
      status: "Active",
    },
  ];

  // SEARCH + SORT + PAGINATION
  const filteredSortedData = useMemo(() => {
    let temp = [...fullData];

    // Search
    if (search) {
      const lowerSearch = search.toLowerCase();
      temp = temp.filter((item) =>
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(lowerSearch),
        ),
      );
    }

    // Sort
    switch (sort) {
      case "newest":
        temp.sort((a, b) => b.sno.localeCompare(a.sno));
        break;
      case "oldest":
        temp.sort((a, b) => a.sno.localeCompare(b.sno));
        break;
      case "ascending":
        temp.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "descending":
        temp.sort((a, b) => b.name.localeCompare(a.name));
        break;
      default:
        break;
    }

    return temp;
  }, [search, sort]);

  const totalItems = filteredSortedData.length;
  const totalPages = Math.ceil(totalItems / limit);
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * limit;
    const end = start + limit;
    return filteredSortedData.slice(start, end);
  }, [filteredSortedData, currentPage, limit]);

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
    setSortName(
      {
        newest: "Newest First",
        oldest: "Oldest First",
        ascending: "Alphabetic A-Z",
        descending: "Alphabetic Z-A",
      }[selectedSort] || "Sort by",
    );
  };

  const debouncedSearch = debounce((value) => {
    setSearch(value);
    setCurrentPage(1);
  }, 500);

  const onChangeSearch = (value) => debouncedSearch(value);

  const handlePageChange = (page) => setCurrentPage(page);

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      key: "sno",
      render: (text, record, index) => Number(0) + (index + 1),
    },
    {
      title: "HHSP Specialisation",
      dataIndex: "hhsp",
      key: "hhsp",
    },
    {
      title: "Image / Icon",
      dataIndex: "image",
      key: "image",
      render: (image) => (
        <img
          src={image}
          alt="HHSP"
          style={{ width: 50, height: 50, objectFit: "cover" }}
        />
      ),
    },
    {
      title: "Total No of Service Provider",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Actions
          isEdit={true}
          recordActiveStatus={record.status}
          isActive={true}
          isDelete={true}
          isView={true}
          onClickActive={() => {
            if (record.status === "Active") {
              navigate("/hhsp-activate");
            }
            if (record.status === "Track") {
              navigate("/hhsp-track");
            }
          }}
          onClickView={() => navigate("/home-healthcare-hhsp-view")}
          onClickDelete={() => navigate(`/home-healthcare-hhsp-edit`)}
          onClickEdit={() => navigate(`/home-healthcare-hhsp-edit`)}
        />
      ),
    },
  ];

  const breadcrumbsList = [
    {
      text: "Home Healthcare Service Provider",
      link: "/home-healthcare-hhsp",
    },
    { text: "HHSP Specialisation", link: "" },
  ];

  return (
    <ListPageLayout
      breadcrumbs={
        <AntdBreadcrumbs
          className="healthsyMasterBreadCrumbs"
          breadcrumbsList={breadcrumbsList}
        />
      }
      addButton={<FilledButton props={addNewHHSPSpecialization} />}
      totalCount={totalItems}
      pagination={{
        currentPage,
        skip: (currentPage - 1) * limit,
        limit,
        totalPages,
        onPageChange: handlePageChange,
      }}
      filters={
        <DoctorsFilterOptions
          limit={limit}
          setLimit={setLimit}
          search={search}
          onChange={onChangeSearch}
          handleSortClick={handleSortClick}
          sortName={sortName}
          setFilterShow={() => {}}
          showFilter={false}
        />
      }
      tableProps={{
        columns,
        dataSource: paginatedData,
        className: "mx-3 pt-2 table-scrollable medicineList_table",
        pagination: false,
      }}
    />
  );
};

export default HHSPSpecialisation;
